export const SCOPE_SERVICE_REQUESTS = 'service_requests';
export const SCOPE_DELIVERIES = 'deliveries';
export const SCOPE_NOTIFICATIONS = 'notifications';
export const SCOPE_THREADS = 'threads';
export const SCOPE_VISITORS = 'visitors';
export const SCOPE_AMENITY_RESERVATIONS = 'amenity_reservations';

export const HEADER_HEIGHT = 65;

export const NOTIFICATIONS_LIST_LIMIT = 50;

export const NOTIFICATION_PATH = {
  SERVICE_REQUEST: 'service_request',
  SERVICE_REQUEST_UPDATE: 'service_request_update',
  SERVICE_REQUEST_PHOTO: 'service_request_photo',
  SERVICE_REQUEST_FEEDBACK: 'service_request_feedback',
  SERVICE_REQUESTS: 'service_requests',
  DELIVERY: 'delivery',
  VISITOR: 'visitor',
  VISITOR_LOG: 'visitor_log',
  BROKER: 'broker',
  BROKER_LOG: 'broker_log',
  AMENITY_RESERVATIONS: 'amenity_reservations',
};
